import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'reasonForMovingInterest',
    'wantToMoveOther',
    'reasonForUsingOmutei',
    'feedbackOnOmutei',
    'reasonForUsingNouzei',
    'wantToRepeatNouzei',
    'wantToRepeatOther',
  ]

  connect() {
    this.toggleReasonForMovingInterest()
    this.toggleWantToMoveOther()
    this.toggleOmuteiFields()
    this.toggleNouzeiFields()
    this.toggleWantToRepeatOther()
  }

  toggleWantToRepeatOther() {
    const checkboxes = document.querySelectorAll('[name="questionnaire[want_to_repeat][]"]')
    const shouldShow = Array.from(checkboxes).some((cb) => cb.checked && cb.value === 'Other')

    this.toggleVisibility(this.wantToRepeatOtherTarget, shouldShow)
  }

  toggleReasonForMovingInterest(event) {
    const value = event?.target?.value || document.querySelector('[name="questionnaire[want_to_move]"]')?.value
    const shouldShow =
      value === 'すぐに移住したい' ||
      value === 'いずれ移住したい' ||
      value === '二拠点居住をしたい' ||
      value === '移住や二拠点に興味はある' ||
      value === 'Yes, I considered relocating.'

    this.toggleVisibility(this.reasonForMovingInterestTarget, shouldShow)
  }

  toggleWantToMoveOther(event) {
    const select = document.querySelector('[name="questionnaire[want_to_move]"]')
    const value = event?.target?.value || select?.value
    const otherValue = select?.dataset?.wantToMoveOtherValue
    const shouldShow = value === otherValue

    this.toggleVisibility(this.wantToMoveOtherTargets[0], shouldShow)
  }

  toggleOmuteiFields(event) {
    const value = event?.target?.value || document.querySelector('[name="questionnaire[used_omutei]"]:checked')?.value
    const shouldShow = value === 'はい'

    this.toggleVisibility(this.reasonForUsingOmuteiTarget, shouldShow)
    this.toggleVisibility(this.feedbackOnOmuteiTarget, shouldShow)
  }

  toggleNouzeiFields(event) {
    const value = event?.target?.value || document.querySelector('[name="questionnaire[used_nouzei]"]:checked')?.value
    const shouldShow = value === 'はい'

    this.toggleVisibility(this.reasonForUsingNouzeiTarget, shouldShow)
    this.toggleVisibility(this.wantToRepeatNouzeiTarget, shouldShow)
  }

  toggleVisibility(target, shouldShow) {
    if (target) {
      target.classList.toggle('hidden', !shouldShow)
    }
  }
}
